module.exports = new __parcel__URL__("head_gltfpack_cctc.8a3dd36f.glb").toString();